import { render, staticRenderFns } from "./projectProcesses.vue?vue&type=template&id=5663a9b8&scoped=true&"
import script from "./projectProcesses.vue?vue&type=script&lang=js&"
export * from "./projectProcesses.vue?vue&type=script&lang=js&"
import style0 from "./projectProcesses.vue?vue&type=style&index=0&id=5663a9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663a9b8",
  null
  
)

export default component.exports